import classNames from 'classnames';
import React from 'react';

import './styles.less';

export default function VideoPlayerButtonHoverTag(props) {
  return (
    <div
      style={{ marginLeft: props.addLeftMargin }}
      className={classNames('video-player-button-hover-tag', props.position, {
        hovered: props.hovered,
      })}
    >
      {props.text}
    </div>
  );
}
